import { parseOutputResponse, saveFileAsExcel } from "../utils/DownloadHelper";
import { ElaborationStatusItem } from "../redux/feature/object/remote-elaborations-slice";
import { axiosInstance, getHeaders } from "../utils/axios";
import { Buffer } from "buffer";

export async function handleExportSubmissionHistoryResult(item: ElaborationStatusItem) {
  if (!item.outputResponse) return;
  if (item.status !== "COMPLETED") return;

  const jobResponse = parseOutputResponse(item.outputResponse);

  if (jobResponse.base64Content) {
    saveFileAsExcel(jobResponse);
    return;
  }
  if (!jobResponse.path) return;

  const headers = await getHeaders(false);

  const response = await axiosInstance.get("/documentpart/file-content", {
    headers,
    params: { path: jobResponse.path },
    responseType: "arraybuffer",
  });

  if (!response?.data) return;
  jobResponse.base64Content = Buffer.from(response.data, "binary").toString("base64");
  saveFileAsExcel(jobResponse);
}
